import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Button from "../CarouselButton";
import "bootstrap/dist/css/bootstrap.min.css";
import Styles from "./Card.module.css";
import { Link, useNavigate } from "react-router-dom";
import borderImage from "../../assets/images/borders-card.png";
import borderOverlay from '../../assets/images/border_overlay-removebg-preview.png'

function BootstrapCard({
    backgroundImage,
    btntext,
    buttonLink,
    extraClass,
    isActive,
    service,
    update
}) {
    const [show, setShown] = useState(false);
    const navigate = useNavigate();

    const getTranslate = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 1550) {
            return 6;
        } else if (screenWidth < 1920) {
            return 2;
        } else {
            return 10;
        }
    };

    const handleClick = () => {
        if (isActive) {
            update();
            setTimeout(() => {
                navigate(buttonLink, {
                    state: { service: service }
                });
            }, 2000);
        }
    };

    return (
        <>
            <div onClick={handleClick} className={`cursor-pointer position-relative ${extraClass}`}
                style={{
                    filter: `${!isActive ? 'brightness(85%)' : 'brightness(100%)'}`,
                    translate: `${isActive ? `0 ${getTranslate()}%` : "0"}`,

                }}
            >
                <Card
                    className={`${Styles.card___} position-relative`}
                    onMouseEnter={() => setShown(true)}
                    onMouseLeave={() => setShown(false)}
                    style={{
                        background: backgroundImage
                            ? `url(${backgroundImage}) center center /cover`
                            : "none",
                    }}
                >
                    {!isActive && (
                        <div className={`${Styles.overlay__card}`}></div>
                    )}
                </Card>

                {
                    isActive && (
                        <div
                            style={{
                                position: 'relative',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                width: '100%'
                            }}
                        >
                            <Button className="btncustom" text={btntext} onClick={() => navigate(buttonLink)} />
                        </div>
                    )
                }
            </div >
        </>
    );
}

export default BootstrapCard;
